
import { useMemo } from 'react';
import { useCatalogQuery } from '../graphql/queries/use-catalog';

export function useCatalog() {
  const { catalog: { collections = [] } = { collections: [] } } = useCatalogQuery() ?? {};

  const [allProducts, allKits] = useMemo(() => {
    const allProducts: Queries.ContentfulCollection['products'] = collections.flatMap(
      (collection: Queries.ContentfulCollection) => collection.products
    );
    const allKits: Queries.ContentfulCollection['kits'] = collections.flatMap(
      (collection: Queries.ContentfulCollection) => collection.kits
    );

    return [allProducts, allKits];
  }, [collections]);

  function findProductBySlug(slug: string) {
    return allProducts?.find((product) => product?.slug === slug) ?? allKits?.find((kit) => kit?.slug === slug);
  }

  return { allProducts, allKits, findProductBySlug };
}
